import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    projectLocationId: Yup.number().nullable().required("Please select a Project Location"),
    description: Yup.string().nullable()
});

